import axios, { AxiosInstance } from 'axios'
import {createAuthProvider} from '../providers/auth'
import {Bundle} from '../types/bundles'
import {Sku} from '../types/skus'

type Constructor = {
  url: string
  authToken: string
}

type FindOptions = {
  page: number
  limit: number
}

class SkuService {
  private api: AxiosInstance

  constructor(param: Constructor) {
    this.api = axios.create({
      baseURL: param.url,
      headers: {
        authorization: param.authToken
      }
    })
  }

  async getSkusByOfferTypeId(offerTypeId: number): Promise<Sku[]> {
    const { data } = await this.api.get('/skus', {
      params: {
        offerTypeId
      }
    })

    return data
  }

  async getBundles(options?: FindOptions): Promise<Bundle[]> {
    const { data } = await this.api.get('/bundles', { params: options })

    return data
  }
}

export function createSkuService() {
  const authProvider = createAuthProvider()

  if (!process.env.REACT_APP_SKU_API_URL) {
    throw new Error('EnvNotFound')
  }

  return new SkuService({
    url: process.env.REACT_APP_SKU_API_URL,
    authToken: `Bearer ${authProvider.getToken()}`
  })
}
